module.exports = __webpack_public_path__ + "static/media/BunburyHerald-devicecomp-min@2x.bd52b3f0.webp";